export enum PropertyCompanyType {
  COMPANY = 'company',
  PROPERTY = 'property',
  MARKET = 'market',
  SUBMARKET = 'submarket',
  MAPBOX_ADDRESS = 'mapbox-address',
}
